import { apiService } from "../ApiService";

export const stopStreamKO = (id: string, error: string) => {
  return apiService.post({
    path: `v1/streams/${id}/stopped`,
    body: { err: error, userExit: false },
    requiresAuthPolicy: "user",
  });
};

export const stopStreamOK = (id: string, message: string, userExit?: boolean) => {
  return apiService.post({
    path: `v1/streams/${id}/stopped`,
    body: { msg: message, userExit },
    requiresAuthPolicy: "user",
  });
};
